import { useState, useRef, useEffect } from "react";
import logo from "../../assets/logos/logo.png";
import bannerPromo from "../../assets/images/promo-banner.jpg";

const Sorteio = () => {
  const [formEnviado, setFormEnviado] = useState(false);
  const loadCount = useRef(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleIframeLoad = () => {
    loadCount.current += 1;
    if (loadCount.current > 1) setFormEnviado(true);
  };

  return (
    <section id="sorteio" className="sorteio-section">
      <div className="sorteio-container">

        {/* Banner agora dentro do card */}
        <img
          src={bannerPromo}
          alt="Promoção Accium"
          className="promo-banner"
        />

        <h2 className="sorteio-title">
          Participe do nosso sorteio
        </h2>

        <p className="sorteio-subtitle">
          Preencha o formulário abaixo com seu nome, celular e e-mail. Você
          receberá automaticamente um número exclusivo no endereço informado
          para concorrer ao nosso prêmio!
        </p>

        <div
          className="iframe-mask-sorteio"
          style={{
            width: "100%",
            height: isMobile ? "740px" : "670px",
            overflow: "hidden",
            borderRadius: "16px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            position: "relative",
          }}
        >
          {!formEnviado ? (
            <iframe
              className="sorteio-iframe"
              src="https://docs.google.com/forms/d/e/1FAIpQLScrvew38uEorGGQjIRNyoxouiZ23KoaM-3UqzEqL3huGRDRkQ/viewform?embedded=true"
              title="Formulário de Sorteio ACCIUM"
              scrolling="no"
              onLoad={handleIframeLoad}
            />
          ) : (
            <div
              className="mensagem-sucesso"
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                background: "#232323",
                textAlign: "center",
                borderRadius: "16px",
                padding: "40px",
              }}
            >
              <img
                src={logo}
                alt="Logo ACCIUM"
                style={{ width: "100px", marginBottom: "20px" }}
              />

              <h3
                style={{
                  color: "#f67f28",
                  fontSize: "1.8rem",
                  marginBottom: "10px",
                }}
              >
                Obrigado por participar!
              </h3>

              <p style={{ fontSize: "1rem", color: "#ffffff" }}>
                Seu número de sorteio será enviado ao e-mail informado.
              </p>

              <button
                onClick={() => {
                  setFormEnviado(false);
                  loadCount.current = 0;
                }}
                style={{
                  marginTop: "20px",
                  backgroundColor: "#f67f28",
                  color: "#232323",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 20px",
                  fontSize: "1rem",
                  cursor: "pointer",
                }}
              >
                Enviar outro formulário
              </button>
            </div>
          )}
        </div>

        <p className="sorteio-note">
          Ao participar deste sorteio, você autoriza o uso dos seus dados
          pessoais para fins de identificação e contato, conforme previsto na
          Lei nº 13.709/2018 (LGPD).
        </p>

      </div>
    </section>
  );
};

export default Sorteio;